// Mesure des conversions (PostHog, chargé par la plateforme).
// Chaque événement emporte la page d'origine : on saura quelle page génère des devis.
export const track = (event, props = {}) => {
  try {
    if (typeof window !== "undefined" && window.posthog && window.posthog.capture) {
      window.posthog.capture(event, { page: window.location.pathname, ...props });
    }
  } catch {
    // l'analytics ne doit jamais bloquer l'expérience
  }
};
